import PopoverComponent from '@/components_v2/PopoverComponent';
import React from 'react';

import {
  Badge,
  Block,
  BlockContent,
  Collaborator,
  Container,
  CountContent,
  Justification,
  TooltipContent,
} from '../../styles';

export interface DefaultToolTipProps {
  color: string;
  value: string;
  defaultCountPercentage?: boolean;
  tooltipNumber?: boolean;
  count_percentage?: string;
  justification?: string;
  collaborator?: string;
  checkin_at?: string;
  checkout_at?: string;
  total?: string;
}

export const DefaultTooltip: React.FC<DefaultToolTipProps> = ({
  color,
  value,
  defaultCountPercentage,
  count_percentage,
  justification,
  collaborator,
  checkin_at,
  checkout_at,
  total,
}: DefaultToolTipProps) => {
  return (
    <Container color={color}>
      {value && value !== '-' && (
        <PopoverComponent placement="top" trigger={<Badge value={value} />}>
          {defaultCountPercentage ? (
            <CountContent>
              <h3>{count_percentage ?? '-'}</h3>
            </CountContent>
          ) : (
            <TooltipContent isJustification={!!justification}>
              <Collaborator>
                <h3>NOME DO PROMOTOR</h3>
                <p>{collaborator || '-'}</p>
              </Collaborator>
              <Block>
                <BlockContent>
                  <h3>IN</h3>
                  <p>{checkin_at || '-'}</p>
                </BlockContent>
                <BlockContent>
                  <h3>OUT</h3>
                  <p>{checkout_at || '-'}</p>
                </BlockContent>
                <BlockContent>
                  <h3>TOTAL</h3>
                  <p>{total || '-'}</p>
                </BlockContent>
              </Block>
              {justification && (
                <Justification>
                  <h3>JUSTIFICATIVA</h3>
                  <p>{justification}</p>
                </Justification>
              )}
            </TooltipContent>
          )}
        </PopoverComponent>
      )}
    </Container>
  );
};
